module.exports = __webpack_public_path__ + "static/media/robert-daponte.5a206446.md";